var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimulationFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.46875V28.5C0 29.2969 0.65625 30 1.5 30H23.0625C23.8594 30 24.5625 29.3438 24.5625 28.5L24.6094 1.5C24.6094 0.703125 23.9531 0 23.1094 0L6.46875 0L0 6.46875Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11035 6.46875H0.0478516L6.46973 0L6.42285 5.0625C6.46973 5.85938 5.86035 6.46875 5.11035 6.46875Z",
    fill: "#126DD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2822 22.7803C15.803 22.7803 18.6572 19.9261 18.6572 16.4053C18.6572 12.8845 15.803 10.0303 12.2822 10.0303C8.76141 10.0303 5.90723 12.8845 5.90723 16.4053C5.90723 19.9261 8.76141 22.7803 12.2822 22.7803Z",
    fill: "#006AB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5615 16.4043L10.499 12.5605V20.248L15.5615 16.4043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulationFileIcon);
export default __webpack_public_path__ + "static/media/simulationFileIcon.e0292033290aacfc08803822e115a648.svg";
export { ForwardRef as ReactComponent };